import { Icon } from 'core-ui';
import { FileSvg } from './svg';

export default () => (
    <Icon component={FileSvg} />
);
